import React from 'react';
import { Box } from '../primitives';
import rem from '../../utils/rem';

type Props = {
  top?: number | string;
  right?: number | string;
  left?: number | string | undefined;
};

const Pin = ({ top = 0, right = 0, left = undefined }: Props) => (
  <Box
    position="absolute"
    top={top}
    right={right}
    left={left}
    size={rem(14)}
    bg="accent"
    borderRadius="50%"
    border="2px solid #ffffff"
  />
);

export default Pin;
